import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-gallery",
  templateUrl: "./gallery.component.html",
  styleUrls: ["./gallery.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class GalleryComponent {
  @Input() public gallery;

  public countImg;
  public currentImg = 0;
  public loadedImg = 0;

  constructor() {}

  ngOnInit(): void {
    this.countImg = this.gallery.length;
  }

  public changeImg(value: number) {
    this.currentImg += value;
    if (this.currentImg < 0) {
      this.currentImg = this.countImg - 1;
    }
    if (this.currentImg > this.countImg - 1) {
      this.currentImg = 0;
    }
  }
}
